import React from 'react';
import { Column } from '@ant-design/plots';
import GraphLoader from '../../../../../../../../Components/ContentLoaders/GraphLoader';
import { EmptyState } from '../../../../../../../../Packages/EmptyState';

const BenchmarkBarChart = (props) => {
    let data = props.fetchTotalFeedbackProvidersStrengthAndDevApi.data != null ? props.fetchTotalFeedbackProvidersStrengthAndDevApi.data : [];
    const categories = [...new Set(data.map(i => i.category))];
    const isSingleCategory = categories.length === 1;
    const config = {
        data,
        height: 450,
        xField: 'category',
        yField: 'value',
        isGroup: true,
        seriesField: 'metric',

        columnWidthRatio: 0.4,
        dodgePadding: isSingleCategory ? undefined : 8,
        maxColumnWidth: 60,
        columnStyle: {
            radius: [2, 2, 0, 0],
        },

        color: ['#135e77', '#eb6a2e'],

        yAxis: false,

        xAxis: {
            label: {
                autoRotate: false,
            },
            grid: null,
        },

        padding: [120, 24, 48, 48],

        legend: {
            position: 'top',
            flipPage: false,
            maxRow: 1,

            itemSpacing: 20,
            maxItemWidth: 400,
            marker: {
                symbol: 'square',
                style: {
                    r: 7,
                    // size: 20,            
                },
            },
            itemName: {
                formatter: (text) => {
                    if (text === 'Strengths')
                        return '% of Feedback Providers that provided Strengths';
                    if (text === 'Development Areas')
                        return '% of Feedback Providers that provided Development Areas';
                    return text;
                },
                style: {
                    fontSize: 14,
                    fontWeight: 400,
                },
            },
        },

        label: {
            position: 'top',
            formatter: (item) => `${item.value}%`,
            style: {
                fill: '#333',
                fontWeight: 400,
                fontSize: 18,
            },
        },

        tooltip: {
            formatter: (item) => ({ name: item.metric, value: `${item.value}%` }),
        },

        responsive: true,


        interactions: [
            { type: 'legend-filter', enable: false },
            { type: 'legend-highlight', enable: false },
        ],
    };


    return (
        <div className='cardwrapper'>
            <h3>Strengths and Areas for Growth</h3>
            <p className='description-container'>This chart shows the % of feedback providers by each group that provided strengths and areas for growth.</p>
            {
                props.fetchTotalFeedbackProvidersStrengthAndDevApi.isProcessing ? <GraphLoader height={300} width={600} /> :
                    (props.fetchTotalFeedbackProvidersStrengthAndDevApi.error && props.fetchTotalFeedbackProvidersStrengthAndDevApi.data === null) || (props.fetchTotalFeedbackProvidersStrengthAndDevApi.data != null && props.fetchTotalFeedbackProvidersStrengthAndDevApi.data.length === 0) ?
                        < EmptyState emptyStateMessage="No data found" /> :


                        <Column {...config} />
            }

        </div>
    );
};

export default BenchmarkBarChart;
